import type { ContentItem, ContentType } from "@/types/content";
import { contentItems } from "@/mocks/content";

export const typeLabels: Record<ContentType, string> = {
  plot: "剧情介绍",
  character: "角色分析",
  news: "最新资讯",
};

export const typeBadgeClass: Record<ContentType, string> = {
  plot: "bg-primary-100 text-primary-800",
  character: "bg-accent-100 text-accent-800",
  news: "bg-secondary-100 text-secondary-800",
};

export function formatDate(dateStr: string): string {
  const [y, m, d] = dateStr.split("-");
  if (!y || !m || !d) return dateStr;
  return `${y}.${m}.${d}`;
}

export function getByType(type: ContentType): ContentItem[] {
  return contentItems.filter((item) => item.type === type) as ContentItem[];
}

export function getAllItems(): ContentItem[] {
  return contentItems as ContentItem[];
}

export function getItemById(id: string): ContentItem | undefined {
  return (contentItems as ContentItem[]).find((item) => item.id === id);
}

export function searchItems(keyword: string, type?: ContentType | "all"): ContentItem[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return (contentItems as ContentItem[]).filter((item) => {
    if (type && type !== "all" && item.type !== type) return false;
    const haystack = [item.title, item.summary, item.subtitle || "", ...(item.tags || [])]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function getRelated(item: ContentItem, count = 3): ContentItem[] {
  return (contentItems as ContentItem[])
    .filter((c) => c.type === item.type && c.id !== item.id)
    .slice(0, count);
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function totalPages(count: number, pageSize: number): number {
  return Math.max(1, Math.ceil(count / pageSize));
}

export const plotChapterFilters = [
  { key: "all", label: "全部章节" },
  { key: "1-2", label: "第 1 - 2 集" },
  { key: "3-4", label: "第 3 - 4 集" },
  { key: "5-6", label: "第 5 - 6 集" },
];

export const characterRoleFilters = [
  { key: "all", label: "全部身份" },
  { key: "领衔主演", label: "领衔主演" },
  { key: "主线人物", label: "主线人物" },
  { key: "亲情线", label: "亲情线" },
  { key: "情感线", label: "情感线" },
  { key: "支线人物", label: "支线人物" },
];

export const newsDateFilters = [
  { key: "all", label: "全部时间" },
  { key: "2026-10", label: "2026 年 10 月" },
  { key: "2026-09", label: "2026 年 9 月" },
];

export function getFilterOptions(type: ContentType) {
  if (type === "plot") return plotChapterFilters;
  if (type === "character") return characterRoleFilters;
  return newsDateFilters;
}